module.exports = __webpack_public_path__ + "img/aimPoint3.a7c355b8.png";